import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=bb9462e6&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=bb9462e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9462e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/TaskFrontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb9462e6')) {
      api.createRecord('bb9462e6', component.options)
    } else {
      api.reload('bb9462e6', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=bb9462e6&scoped=true", function () {
      api.rerender('bb9462e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notice/components/detail.vue"
export default component.exports